import { createStore } from "vuex";
import ApiService from "../../src/service/ApiService";
const apiService = new ApiService();
import commonFunction from "../composables/commonFunction";
const { decrypteData, checkEmpty } = commonFunction();
import {
  getdistricts,
  getboothnumberlist,
  getProfessions,
  getbloodgroups,
  gettags,
  getEmployerTypeList,
  getIndustries,
  getCompanyTypes,
  getFamilyRelations,
  getClientDesignations,
  getCountryCodeList,
  getModules,
  getAllTitle,
  getCities,
  getStates,
  getEducationList,
  getActiveUsers,
  getLokSabha,
  getVidhansabha,
  getCallbackNumbers,
  getDesignationSets,
} from "../composables/commonAPIFunctions";

export default createStore({
  state: {
    masterbucketname: "meraneta_admin",
    systemStatus: {},
    loggedInUserSessions: {
      user: null,
      client_info: null,
      user_reference: null,
      permission_fks: null,
      clientfk: null,
      userfk: null,
    },

    AuthenticatedUserHeader: {
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
      "content-type": "application/json",
      Accept: "application/json",
    },
    filterModal: false,
    teamLeadOptions: [], // Dropdown options for Team Lead
    userStatusOptions: [
      { value: 1, label: "Active" },
      { value: 2, label: "Temporary Suspended" },
      { value: 3, label: "Permanent Suspended" },
    ],
    teamLead: "", // Selected team lead
    userStatus: "", // Selected user status
    viewVoterModal: {}, //props for view voter modal
    editUserModal: {}, //props for edit user modal
    editPermissionsModal: {},
    permissionSet: {},
    addPermissionsModal: {},
    addCampaignModal: {},
    campaignListingFlag: false,
    editCampaignModal: {},
    editCampaignModalFlag: false,
    editVoterModal: {}, //props for edit voter modal
    followUpVoterModalFlag: false,
    followUpVoterModal: null,
    webHistoryModalData: {}, //props for web history modal
    webBotModalData: {}, //props for web Bot modal
    addUserModal: false, //add user modal
    editVoterFlag: false,
    editUserFlag: false,
    filterVoterModal: false,
    campaignModal: null,
    voterListPayload: {},
    mismatchBy: null,
    openWebBotFlag: false,
    campainTemplateTab: "",
    reloadCampaignTemplateFlag: false,
    genderList: [
      { label: "Male", value: 1 },
      { label: "Female", value: 2 },
      { label: "Others", value: 3 },
    ],
    ticketHistoryData: {},
    ticketHistoryDataFlag: false,
    supportTicketData: {},
    ticketTableLoader: false,
    reloadSupportTicketFlag: false,
    reloadTicketsType: "",
  },

  mutations: {
    updateLoggedInUserSessions(state, data) {
      state.systemStatus = data;
      state.loggedInUserSessions.user = data.user_data;
      state.loggedInUserSessions.user_reference = data.user_reference;
      state.loggedInUserSessions.permission_fks = data.permission_fks;
      state.loggedInUserSessions.client_info = data.client_info;
      state.loggedInUserSessions.storagePath = data.storagePath;
      state.AuthenticatedUserHeader["Authorization"] =
        "Bearer " + data.user_reference;
      state.AuthenticatedUserHeader["user"] = JSON.stringify(data.user_data);
    },
    setClientInfo(state, clientInfo) {
      state.loggedInUserSessions.client_info = clientInfo;
      state.loggedInUserSessions.clientfk = clientInfo.maa1;
      state.AuthenticatedUserHeader["client"] = clientInfo.maa1;
    },
    addOrUpdateClientInfo(state, data) {
      state.loggedInUserSessions.client_info = data;
      state.AuthenticatedUserHeader["client"] = data.maa1;
    },
    addOrUpdateClientUserInfo(state, data) {
      state.loggedInUserSessions.user = data;
      state.AuthenticatedUserHeader["user"] = JSON.stringify(data);
    },

    // Generic mutation to set API response data
    setData(state, { key, data }) {
      state[key] = data;
    },
    setLoading(state, status) {
      state.loading = status;
    },
    setError(state, error) {
      state.error = error;
    },

    //props for view voter modal
    viewVoterDetailsModal(state, data) {
      state.viewVoterModal = data;
    },
    editUserModal(state, data) {
      state.editUserModal = data;
      state.editUserFlag = !state.editUserFlag;
    },
    campaignListingFlag(state) {
      state.campaignListingFlag = !state.campaignListingFlag;
    },
    editPermissionsModal(state, data) {
      state.editPermissionsModal = data;
    },
    permissionSet(state, data) {
      state.permissionSet = data;
    },
    addPermissionsModal(state, data) {
      state.addPermissionsModal = data;
    },
    addCampaignModal(state, data) {
      state.addCampaignModal = data;
    },
    editCampaignModal(state, data) {
      state.editCampaignModal = data;
    },
    editCampaignModalFlag(state, data) {
      state.editCampaignModalFlag = data;
    },
    //props for edit voter modal
    editVoterDetailsModal(state, data) {
      state.editVoterModal = data;
    },
    openWebHistoryModal(state, data) {
      state.webHistoryModalData = data;
    },
    openWebBotModal(state, data) {
      state.webBotModalData = data;
    },

    // Open/close filter modal
    addOrUpdateFilterModalOpen(state, data) {
      state.filterModal = data;
    },
    viewCampaignModal(state, data) {
      state.campaignModal = data;
    },
    // Mutation to reset the campaign modal (close it)
    resetCampaignModal(state) {
      state.campaignModal = null; // This will close the modal
    },
    updateVoterFilterModalFlag(state, flag) {
      state.filterVoterModal = flag;
    },

    // Set the dropdown options for user statuses
    setUserStatusOptions(state, userStatusOptions) {
      state.userStatusOptions = userStatusOptions;
    },

    // Apply filters (team lead and user status)
    applyFilters(state, payload) {
      state.filterData = payload;
      state.filterModal = false;
    },

    // Reset filters
    resetFilters(state) {
      state.filterModal = false;
      state.filterData = null;
    },

    openVoterUpdateModal(state) {
      state.openvoterupdatemodal = !state.openvoterupdatemodal;
    },
    addUserModal(state, payload) {
      state.addUserModal = payload;
    },
    updateVoterFlag(state) {
      state.editVoterFlag = !state.editVoterFlag;
    },
    updateUserFlag(state) {
      state.editUserFlag = !state.editUserFlag;
    },
    reloadVoterList(state, payload) {
      state.voterListPayload = payload;
    },
    setMismatchVoterFilter(state, filter) {
      state.mismatchBy = filter; // Update the mismatchBy state
    },
    changeCampaignTemplateTab(state, payload) {
      state.campainTemplateTab = payload;
    },
    reloadCampaignTemplateFlag(state, payload) {
      state.reloadCampaignTemplateFlag = payload;
    },
    setTicketHistoryData(state, payload) {
      state.ticketHistoryData = payload;
      state.ticketHistoryDataFlag = !state.ticketHistoryDataFlag;
    },
    supportTicketData(state, payload) {
      state.supportTicketData = payload;
    },
    // setTicketTableLoader(state, payload) {
    //   state.ticketTableLoader = payload;
    // },
    setReloadSupportTicketFlag(state, payload) {
      state.reloadSupportTicketFlag = !state.reloadSupportTicketFlag;
      state.reloadTicketsType = payload;
    },
    setFollowUpVoterModal(state, payload) {
      state.followUpVoterModal = payload;
      state.followUpVoterModalFlag = true;
    },

    closeFollowUpVoterModal(state) {
      state.followUpVoterModal = null;
      state.followUpVoterModalFlag = false;
    },
  },

  actions: {
    async checkLoginCredentials(context) {
      const client =
        localStorage && localStorage.client_info
          ? JSON.parse(decrypteData(localStorage.client_info))
          : null;
      const user =
        localStorage && localStorage.user_info
          ? JSON.parse(decrypteData(localStorage.user_info))
          : null;

      if (checkEmpty(client) && checkEmpty(user)) {
        this.state.loggedInUserSessions.clientfk = client.maa1;
        this.state.AuthenticatedUserHeader["client"] = client.maa1;
        this.state.loggedInUserSessions.userfk = user.ak1;
        if (
          checkEmpty(this.state.loggedInUserSessions.userfk) &&
          !checkEmpty(this.state.loggedInUserSessions.user_reference)
        ) {
          return await apiService.loginCache({ ak1: user.ak1 }).then((data) => {
            context.commit("updateLoggedInUserSessions", data.data);
            return data;
          });
        }
      }
    },
    addOrUpdateClientInfo(context, payload) {
      context.commit("addOrUpdateClientInfo", payload);
    },
    addOrUpdateClientUserInfo(context, payload) {
      context.commit("addOrUpdateClientUserInfo", payload);
    },

    //Omkar changes start
    viewVoterDetailsModal(context, payload) {
      context.commit("viewVoterDetailsModal", payload);
    },
    editUserDetailsModal(context, payload) {
      context.commit("editUserDetailsModal", payload);
    },
    editVoterDetailsModal(context, payload) {
      context.commit("editVoterDetailsModal", payload);
    },
    //Omkar changes End

    // Toggle filter modal visibility
    addOrUpdateFilterModalOpen(context, payload) {
      context.commit("addOrUpdateFilterModalOpen", payload);
    },
    viewCampaignModal(context, payload) {
      context.commit("viewCampaignModal", payload);
    },

    closeCamapignModal({ commit }) {
      commit("resetCampaignModal");
    },

    // Apply selected filters (trigger the mutation)
    applyFilters(context, payload) {
      context.commit("applyFilters", payload);
    },

    // Reset selected filters (trigger the mutation)
    resetFilters({ commit }) {
      commit("resetFilters");
    },

    // Fetch user status options and commit to state
    async fetchUserStatusOptions({ commit }) {
      try {
        const response = await apiService.getUserStatuses(); // Replace with actual API call
        commit("setUserStatusOptions", response.data);
      } catch (error) {
        console.error("Failed to fetch user status options:", error);
      }
    },

    openVoterUpdateModal(context, payload) {
      context.commit("openVoterUpdateModal", payload);
    },

    addUserModal(content, payload) {
      content.commit("addUserModal", payload);
    },
    editUserModal(content, payload) {
      content.commit("editUserModal", payload);
    },
    editPermissionsModal(content, payload) {
      content.commit("editPermissionsModal", payload);
    },
    permissionSet(content, payload) {
      content.commit("permissionSet", payload);
    },
    addPermissionsModal(content, payload) {
      content.commit("addPermissionsModal", payload);
    },
    addCampaignModal(content, payload) {
      content.commit("addCampaignModal", payload);
    },
    campaignListingFlag(content) {
      content.commit("campaignListingFlag");
    },
    editCampaignModal(content, payload) {
      content.commit("editCampaignModal", payload);
    },
    editCampaignModalFlag(content, payload) {
      content.commit("editCampaignModalFlag", payload);
    },
    openWebHistoryModal(content, payload) {
      content.commit("openWebHistoryModal", payload);
    },
    openFollowUpVoterModal({ commit }, payload) {
      commit("setFollowUpVoterModal", payload);
    },
    closeFollowUpVoterModal({ commit }) {
      commit("closeFollowUpVoterModal");
    },
    updateVoterFlag(content) {
      content.commit("updateVoterFlag");
    },
    updateUserFlag(content) {
      content.commit("updateUserFlag");
    },
    updateVoterFilterModalFlag(content, payload) {
      content.commit("updateVoterFilterModalFlag", payload);
    },
    reloadVoterList(content, payload) {
      content.commit("reloadVoterList", payload);
    },
    // Generic action for fetching data and storing it in different state variables
    async fetchData({ commit }, { apiCall, stateKey, payload }) {
      commit("setLoading", true);
      try {
        const { status, data } = await apiCall(payload);
        if (status === 200) {
          commit("setData", { key: stateKey, data });
        } else {
          commit("setData", { key: stateKey, data: null });
        }
      } catch (error) {
        commit("setError", error);
      } finally {
        commit("setLoading", false);
      }
    },
    // Dispatch the API calls for each specific case
    fetchDistricts({ dispatch }, payload) {
      dispatch("fetchData", {
        apiCall: getdistricts,
        stateKey: "filterdistrictList",
        payload: payload,
      });
    },

    fetchBoothNumberList({ dispatch }, payload) {
      dispatch("fetchData", {
        apiCall: getboothnumberlist,
        stateKey: "boothNumberList",
        payload: payload,
      });
    },

    fetchProfessions({ dispatch }, payload) {
      dispatch("fetchData", {
        apiCall: getProfessions,
        stateKey: "professions",
        payload: payload,
      });
    },

    fetchBloodGroups({ dispatch }, payload) {
      dispatch("fetchData", {
        apiCall: getbloodgroups,
        stateKey: "bloodGroups",
        payload: payload,
      });
    },

    fetchTags({ dispatch }, payload) {
      dispatch("fetchData", {
        apiCall: gettags,
        stateKey: "tags",
        payload: payload,
      });
    },

    fetchEmployerTypeList({ dispatch }, payload) {
      dispatch("fetchData", {
        apiCall: getEmployerTypeList,
        stateKey: "employerTypeList",
        payload: payload,
      });
    },

    fetchIndustries({ dispatch }, payload) {
      dispatch("fetchData", {
        apiCall: getIndustries,
        stateKey: "industries",
        payload: payload,
      });
    },

    fetchCompanyTypes({ dispatch }, payload) {
      dispatch("fetchData", {
        apiCall: getCompanyTypes,
        stateKey: "companyTypes",
        payload: payload,
      });
    },
    fetchFamilyRelations({ dispatch }, payload) {
      dispatch("fetchData", {
        apiCall: getFamilyRelations,
        stateKey: "familyRelations",
        payload: payload,
      });
    },
    fetchClientDesignations({ dispatch }, payload) {
      dispatch("fetchData", {
        apiCall: getClientDesignations,
        stateKey: "clientDesignations",
        payload: payload,
      });
    },
    fetchCountryCodeList({ dispatch }, payload) {
      dispatch("fetchData", {
        apiCall: getCountryCodeList,
        stateKey: "countryCodeList",
        payload: payload,
      });
    },
    fetchEducationList({ dispatch }, payload) {
      dispatch("fetchData", {
        apiCall: getEducationList,
        stateKey: "educationList",
        payload: payload,
      });
    },
    fetchAllTitles({ dispatch }, payload) {
      dispatch("fetchData", {
        apiCall: getAllTitle,
        stateKey: "allTitleList",
        payload: payload,
      });
    },
    fetchCities({ dispatch }, payload) {
      dispatch("fetchData", {
        apiCall: getCities,
        stateKey: "citiesList",
        payload: payload,
      });
    },
    fetchStates({ dispatch }, payload) {
      dispatch("fetchData", {
        apiCall: getStates,
        stateKey: "statesList",
        payload: payload,
      });
    },
    fetchActiveUsers({ dispatch }, payload) {
      dispatch("fetchData", {
        apiCall: getActiveUsers,
        stateKey: "activeUsersList",
        payload: payload,
      });
    },
    fetchLokSabha({ dispatch }, payload) {
      dispatch("fetchData", {
        apiCall: getLokSabha,
        stateKey: "lokSabhaList",
        payload: payload,
      });
    },
    fetchVidhansabha({ dispatch }, payload) {
      dispatch("fetchData", {
        apiCall: getVidhansabha,
        stateKey: "vidhanSabhaList",
        payload: payload,
      });
    },
    fetchModules({ dispatch }, payload) {
      dispatch("fetchData", {
        apiCall: getModules,
        stateKey: "moduleList",
        payload: payload,
      });
    },

    fetchCallbackNumbers({ dispatch }, payload) {
      dispatch("fetchData", {
        apiCall: getCallbackNumbers,
        stateKey: "callbackNumberList",
        payload: payload,
      });
    },
    fetchDesignationSets({ dispatch }, payload) {
      dispatch("fetchData", {
        apiCall: getDesignationSets,
        stateKey: "designationSetList",
        payload: payload,
      });
    },

    setMismatchVoterFilter({ commit }, filter) {
      commit("setMismatchVoterFilter", filter); // Commit the mutation to update state
    },
    changeCampaignTemplateTab(content, payload) {
      content.commit("changeCampaignTemplateTab", payload);
    },
    reloadCampaignTemplateFlag(content, payload) {
      content.commit("reloadCampaignTemplateFlag", payload);
    },
    ticketHistoryData(content, payload) {
      content.commit("setTicketHistoryData", payload);
    },
    supportTicketData(content, payload) {
      content.commit("supportTicketData", payload);
    },
    setTicketTableLoader(content, payload) {
      content.commit("setTicketTableLoader", payload);
    },
    reloadSupportTickets(content, payload) {
      content.commit("setReloadSupportTicketFlag", payload);
    },
  },

  getters: {
    getFilterDistrictList: (state) => state.filterdistrictList,
    getBoothNumberList: (state) => state.boothNumberList,
    getProfessions: (state) => state.professions,
    getBloodGroups: (state) => state.bloodGroups,
    getTags: (state) => state.tags,
    getEmployerTypeList: (state) => state.employerTypeList,
    getIndustries: (state) => state.industries,
    getCompanyTypes: (state) => state.companyTypes,
    getFamilyRelations: (state) => state.familyRelations,
    getClientDesignations: (state) => state.clientDesignations,
    getCountryCodeList: (state) => state.countryCodeList,
    getEducationList: (state) => state.educationList,
    getAllTitles: (state) => state.allTitleList,
    getCities: (state) => state.citiesList,
    getStates: (state) => state.statesList,
    getActiveUsers: (state) => state.activeUsersList,
    getGenderList: (state) => state.genderList,
    getLoksabhaList: (state) => state.lokSabhaList,
    getVidhansabhaList: (state) => state.vidhanSabhaList,
    getModules: (state) => state.moduleList,
    getCallbackNumbers: (state) => state.callbackNumberList,
    getDesignationSetList: (state) => state.designationSetList,
  },
});
